
import React from "react"
import {Container} from "@mui/material";
import BodyCopyB from "../components/BodyCopy-B";
import LeadForm from "../components/LeadForm";
import PageFooter from "../components/PageFooter";
import PageHeader from "../components/PageHeader";
import { useParams } from "react-router-dom";
import { string } from "yup";
import { PinDropSharp } from "@mui/icons-material";


function HomeB () {

  let params=useParams();
  let src="BDEF" ;
 console.log(params.src)
 src=params.src;


 if (!params.src) {
src="B-DEF"
} else {
src=params.src;
}


console.log(src);


  return (

<div>

  <PageHeader/>
  <BodyCopyB/>
  <LeadForm  src={src}  />
  <PageFooter/>


</div>
);
}

export default HomeB;